var map = {
	"./halter.png": "9ab7",
	"./hospitals.png": "5f57",
	"./max.png": "35a5",
	"./red-dot.png": "53ce",
	"./star.png": "4dc5",
	"./yellow-dot.png": "dfe6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d488";